import React from 'react';
import BasePage from '../BasePage/BasePage';
import EditorialPageContent from './EditorialPageContent/EditorialPageContent';
import SEO from "../../components/SEO/SEO";
import {withPrefix} from 'gatsby'

const EditorialPage = ({pageContext: {editorial}}) => {
    const [headerClass, setHeaderClass] = React.useState(null);
    return (
        <>
            <SEO title={editorial.title} canonicalPath={withPrefix(`/editorial/${editorial.slug}`)}/>
            <BasePage headerClass={headerClass} >
                <EditorialPageContent editorial={editorial} setHeaderClass={setHeaderClass} />
            </BasePage>
        </>
    )
}

export default EditorialPage